import React from 'react'
import Banner from './components/Banner/Banner'
import Feature from './components/Feature/Feature'
import Channel from './components/chanel/Channel'
import Member from './components/member/Member'
import Education from './components/education/Education'
import SpecialChannel from './components/SpecialChannel/SpecialChannel'
import Header from '../../components/layouts/Header/Header'
import HeaderGap from '../../components/layouts/Header/HeaderGap'

function Home() {
    return (
        <div>
            <Header/>
            <HeaderGap/>
            <Banner/>
            <Feature/>
            <Channel/>
            <Member/>
            <Education/>
            <SpecialChannel/>
        </div>
    )
}

export default Home
